import { LegacyIcon } from '@gonfalon/icons/LegacyIcon';
import type { LegacyIconProps } from '@gonfalon/icons/types';
import cx from 'clsx';

import LuaSvgColor from '../assets/lua.svg';

export const LuaColor = ({ className, size, ...props }: LegacyIconProps) => (
  <LegacyIcon name="color-lang-lua" className={cx('sdkIcon', className)} size={size} {...props}>
    <LuaSvgColor />
  </LegacyIcon>
);
